import endpoints from '../api/endpoints'

const resetActions = {
  LOGIN_RESET_STORE: 'LOGIN_RESET_STORE'
}

const ActionTypes = {
  API_REQUEST: "API_REQUEST",
  LOGOUT: "LOGOUT",
  VEHICLES_INVALID: "VEHICLES_INVALID",
  VEHICLES_TABLE_REMOVE: "VEHICLES_TABLE_REMOVE",
  VEHICLES_LOOKUP_ASYNC: "VEHICLES_LOOKUP_ASYNC",
  DASHBOARD_CLEAR_FILTER: "DASHBOARD_CLEAR_FILTER",
  DASHBOARD_CLEAR_DRIVER_FILTER: "DASHBOARD_CLEAR_DRIVER_FILTER",
  DASHBOARD_ADD_FILTER: "DASHBOARD_ADD_FILTER",
  DASHBOARD_ADD_DRIVER_FILTER: "DASHBOARD_ADD_DRIVER_FILTER",
  DASHBOARD_SET_DATE: "DASHBOARD_SET_DATE",
  FLEET_CHECK_VEHICLE: "FLEET_CHECK_VEHICLE",
  FLEET_SET_MODE: "FLEET_SET_MODE",
  PAYMENT_REQUIRED: "PAYMENT_REQUIRED",
  SELECT_USER: "SELECT_USER",
  SELECT_USER_DESTROY: "SELECT_USER_DESTROY",
  STRIPE_CREATE_SETUP_INTENT: "STRIPE_CREATE_SETUP_INTENT",
  TOGGLE_ROW: "TOGGLE_ROW",
  TOGGLE_ALL: "TOGGLE_ALL",
  GROUP_EXPAND: "GROUP_EXPAND",
  GROUP_SELECT: "GROUP_SELECT",
  TAG_SELECT: "TAG_SELECT",
  LIMIT: "LIMIT",
  ...resetActions,
}

const apiActions = Object.keys(endpoints).map(e =>
  [e, `${e}_START`, `${e}_SUCCESS`, `${e}_FAILURE`, `${e}_RESET_STORE`]
).flat()

apiActions.forEach(a => { ActionTypes[a] = a })

export default ActionTypes

// Originally this was auto-generated, but it stopped working after a babel update...
export const {
  ACCOUNT,
  ACCOUNT_CREATE,
  ACCOUNT_UPDATE,
  API_REQUEST,
  ATTACHMENTS,
  ATTACHMENTS_CREATE,
  ATTACHMENTS_UPDATE,
  ATTACHMENTS_DESTROY,
  BILLING_INDEX,
  CONFIG,
  DASHBOARD,
  DASHBOARD_CLEAR_FILTER,
  DASHBOARD_CLEAR_DRIVER_FILTER,
  DASHBOARD_ADD_FILTER,
  DASHBOARD_ADD_DRIVER_FILTER,
  DASHBOARD_ASSIGN_DRIVERS,
  DASHBOARD_SET_DATE,
  DRIVERS,
  DRIVERS_CREATE,
  DRIVERS_CREATE_FAILURE,
  DRIVERS_CREATE_RESET_STORE,
  DRIVERS_CREATE_START,
  DRIVERS_CREATE_SUCCESS,
  DRIVERS_GUEST,
  DRIVERS_GUEST_NEW,
  DRIVERS_INVITE,
  DRIVERS_INVITE_RESET_STORE,
  DRIVERS_PENDING,
  DRIVERS_SHOW,
  DRIVERS_SHOW_RESET_STORE,
  DRIVERS_UNASSOCIATE,
  DRIVERS_UPDATE,
  GROUP_EXPAND,
  GROUP_SELECT,
  GROUPS_ASSIGN,
  GROUPS_UNASSIGN,
  GROUPS_CREATE,
  GROUPS_UPDATE,
  GROUPS_DESTROY,
  LOGIN,
  LOGIN_RESET_STORE,
  LOGOUT,
  NOTIFICATIONS,
  NOTIFICATIONS_UPDATE,
  NOTIFICATIONS_ACKNOWLEDGE_ALL,
  ORGANISATIONS_SHOW,
  ORGANISATIONS_UPDATE,
  PASSWORD_RESET,
  PASSWORD_CHANGE,
  PAYMENT_REQUIRED,
  FILE_DOWNLOAD,
  FLEET,
  FLEET_CHECK_VEHICLE,
  FLEET_SET_MODE,
  CURRENT_USER,
  SEARCH,
  SEARCH_RESET_STORE,
  SELECT_USER,
  SELECT_USER_DESTROY,
  SIGN_UP,
  SIGN_UP_FAILURE,
  SIGN_UP_RESET_STORE,
  SIGN_UP_START,
  SIGN_UP_SUCCESS,
  STRIPE_CONFIRM_CARD,
  STRIPE_CONFIRM_CARD_RESET_STORE,
  STRIPE_CONFIRM_DIRECT_DEBIT,
  STRIPE_CONFIRM_DIRECT_DEBIT_RESET_STORE,
  STRIPE_CANCEL_DETAILS,
  STRIPE_CREATE_SETUP_INTENT,
  STRIPE_CREATE_CHECKOUT_SESSION,
  STRIPE_FETCH_PRICES,
  TAGS_ASSIGN,
  TAGS_CREATE,
  TAGS_UPDATE,
  TAGS_DESTROY,
  TAG_SELECT,
  TOGGLE_ROW,
  TOGGLE_ALL,
  USERS,
  USERS_CREATE,
  USERS_DESTROY,
  USERS_DESTROY_FAILURE,
  USERS_DESTROY_RESET_STORE,
  USERS_DESTROY_START,
  USERS_DESTROY_SUCCESS,
  USERS_UPDATE,
  USERS_UPDATE_FAILURE,
  USERS_UPDATE_RESET_STORE,
  USERS_UPDATE_START,
  USERS_UPDATE_SUCCESS,
  USERS_SAVE_COLUMNS,
  VEHICLES_ASSIGN_DRIVERS,
  VEHICLES_UNASSOCIATE,
  VEHICLES_LOOKUP,
  VEHICLES_LOOKUP_ASYNC,
  VEHICLES_LOOKUP_FAILURE,
  VEHICLES_LOOKUP_RESET_STORE,
  VEHICLES_LOOKUP_START,
  VEHICLES_LOOKUP_SUCCESS,
  VEHICLES_CONFIRM,
  VEHICLES_SHOW,
  VEHICLES_SHOW_RESET_STORE,
  VEHICLES_IMAGE,
  VEHICLES_INVALID,
  VEHICLES_REFRESH,
  VEHICLES_TABLE_REMOVE,
  LIMIT,
} = ActionTypes
